import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import {Box, MainHeading, Description, Divider} from '../../StyledComponents';
import _ from 'lodash';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

const SegmentBlocks = styled.div`
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
  display: inline-block;
`;

const Block = styled.div`
  display: inline-block;
  margin-right:5px;
  padding:5px;
`;

const BlockTitle = styled.span`
  display: block;
  color: #2f4962;
  font-weight:bold;
  font-size:10px;
  text-transform: uppercase;
`;
const BlockText = styled.span`
  display: block;
  font-size:14px;
`;

const Legend = styled.div`
  margin-top:10px;
`;

const LegendDot = styled.div`
  background:#49a184;
  border-radius:50%;
  width:10px;
  height:10px;
  display:inline-block;
  margin-right:3px;

  ${props => props.secondary && css`
    background:#fd6d22;
  `}
`;

const LegendItem = styled.div`
  display: inline-block;
  margin-right:20px;
  text-transform: uppercase;
  font-size:11px;
`;

const Sliders = styled.div`
  margin-top: 30px;
`;


const VariableContainer = styled.div`
  margin-bottom:3px;
`;

const SliderContainer = styled.div`
  margin-bottom: 18px;
  margin-top:-18px;
  display:block;
  width:210px;
  float:right;
  display:block;
`;

const SliderLabel = styled.span`
  font-size:11px;
  display:inline-block;
  text-transform: uppercase;
`;

const ImpactLabelContainer = styled.span`
  position:relative;
`;

const ImpactLabel = styled.span`
  font-size: 9px;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  width: 30%;
  float: left;
`;

const ImpactSlider = styled(Slider)`
  width: 70%;
  float: right;
  padding-top:4px;
`;

const StyledRange = styled(Range)`
  width: 100%;
  margin-bottom: 20px;
`;

const Tick = styled.div`
  display: block;
  width: 3px;
  height: 10px;
  background: #fff;
  opacity: 1;
  borderRadius:5px;

  ${props => props.score && css`
    background: #5ab99a;
  `}
  ${props => props.target && css`
    background: #fa7823;
  `}
  ${props => props.transparent && css`
    background: transparent;
  `}
`;

const ScoreTooltip = styled.div`
  border-radius: 3px;
  background: #fff;
  position: relative;
  top: -17px;
  left: -8px;
  font-size:10px;
  padding: 0px 3px;
  width: fit-content;
  font-weight: bold;
  color: #5ab99a;
`;

const ScoreMark = styled.div`
  background: #fff;
  position:relative;
  background-image: url("arrow-green.png");
`;

class KeyAttributes extends Component {

    segmentBlocks(segmentBlocks) {
      let blocks = [];
      _.forEach(segmentBlocks, function (block, i) {
        blocks.push(<Block><BlockTitle>{block.title}</BlockTitle><BlockText>{block.text}</BlockText></Block>)
      });

      return <SegmentBlocks>{blocks}</SegmentBlocks>;
    }

    legend() {
      return (<Legend><LegendItem><LegendDot/>Score</LegendItem><LegendItem><LegendDot secondary/>Target score</LegendItem></Legend>);
    }

    buildSliderTicks = function(min,max,stepsize,score, target) {
      let marks = {};
      let scorePosition = null;
      let distance = min > 0 ? (max-min):(-min + max);

      // Distribute 100 ticks evenly
      for (var i=0;i<101;i++) {
        const val = min + i*(stepsize*((distance/stepsize)/100));
        let isScore = val<=score;
        let isTarget = (val >= score && val<=target);
        if (i%3 === 0) {
          marks[val] = {
            style: {},
            label: <Tick score={isScore} target={isTarget}/>,
          };
        };

        if (isScore && !isTarget) {
          scorePosition = val;
        }
      }

      if (!isNaN(scorePosition)) {
        marks[scorePosition] = {
          style: {},
          label: <Tick score={true} transparent={scorePosition%3===0}><ScoreTooltip className="scoreTooltip">{score}</ScoreTooltip><ScoreMark/></Tick>
        };
      }

      return marks;
    }
    isValidNumber(number) {
      return typeof(number) === 'number' && !isNaN(number)
    }

    renderVariables(data) {
      const _this = this;
      const variableNames=["price","product","promotion","preference","proposal","people"/*, "place"*/];
      let output = [];

      // Compensate so weights add up to 100
      let sum = 0;

      variableNames.forEach(variable => {
        const varData = data[variable];
        if (varData) {
          if (varData.id !== "total" && varData.weight) {
            sum += parseFloat(varData.weight);
          }
        }
      });

      let factor = 100/sum;
      let min = parseInt(_this.props.data.variableMin, 10) || 0;
      let max = parseInt(_this.props.data.variableMax, 10) || 100;
      _.forEach(variableNames, function(variable, i) {
        const varData = data[variable];
        if (varData) {
        }
        if (varData && _this.isValidNumber(parseFloat(varData.score)) && _this.isValidNumber(parseFloat(varData.target)) && _this.isValidNumber(parseFloat(varData.weight)) && _this.isValidNumber(factor)) {
          const score = parseFloat(varData.score).toFixed(1);
          const target = parseFloat(varData.target).toFixed(1);

          const adjustedWeight = parseFloat(varData.weight * factor).toFixed(1);
          const weight = (adjustedWeight || "-")+"%"
          output.push(<VariableContainer key={i}>
                        <SliderLabel>{varData.name}</SliderLabel>
                          <SliderContainer>
                             <StyledRange disabled min={min} max={max} count={2} value={[score, target]} marks={_this.buildSliderTicks(min,max,1,score,target)}
                              trackStyle={[{backgroundColor: 'transparent' }, { backgroundColor: 'transparent'}]}
                              railStyle={{ backgroundColor: 'transparent' }} handle={<LegendDot></LegendDot>}/>
                            <ImpactLabelContainer>
                              <ImpactLabel>Impact: {weight}</ImpactLabel>
                              <ImpactSlider disabled value={adjustedWeight} trackStyle={{backgroundColor: "#2f4962", height:'5px', borderRadius:'0'}} railStyle={{backgroundColor:"#6b8290", height:'5px', borderRadius:'0'}}/>
                            </ImpactLabelContainer>

                          </SliderContainer>
                      <div style={{clear:'both'}}/>
                    </VariableContainer>);
        }
      });

      return (<Sliders className="keyAttributes">{output}</Sliders>);

    }

    render() {
      const { propData, user } = this.props;

      const keyAttributeData = {
        "title": "Key parameters",
        "description": "Display the situation of the different parameters and where the largest gaps are.",
        "segmentBlocks":[{title:"Brand:", text:(user.userProfile && user.userProfile.clientName) || (user.userProfile && user.userProfile.client)}, /*{title:"Segment:", text:"Segment 1"}, {title:"Product:", text:"Product 1"}*/],
        "simulated": "N/A"
      };

      const _data = propData || {};
      _data.keyAttributeData = keyAttributeData;

      return (
        <Box>
            <MainHeading>{_data.keyAttributeData.title}</MainHeading>
            <Description>{_data.keyAttributeData.description}</Description>
            <Divider my0/>
            {/* this.segmentBlocks(_data.keyAttributeData.segmentBlocks)*/}
            {this.legend()}

            {this.renderVariables(_data)}
        </Box>
      );

    }
}

function mapStateToProps(state, ownProps) {
  return {
    uid: state.user.uid,
    data: state.data,
    user: state.user
  };
}

export default connect(mapStateToProps)(KeyAttributes);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/KeyAttributes.js